import styled from 'styled-components';

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 70px);
  grid-auto-rows: 70px;
  gap: 12px;
  height: 100%;
`;
